// extracted by mini-css-extract-plugin
export var home = "home-module--home--24INF";
export var profile = "home-module--profile--rL1go";
export var photo = "home-module--photo--1fG3G";
export var main = "home-module--main--26P70";
export var note = "home-module--note--1iMGz";